import { render, staticRenderFns } from "./PalletLabelPage.vue?vue&type=template&id=cdc80166&scoped=true"
import script from "./PalletLabelPage.vue?vue&type=script&lang=js"
export * from "./PalletLabelPage.vue?vue&type=script&lang=js"
import style0 from "./PalletLabelPage.vue?vue&type=style&index=0&id=cdc80166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc80166",
  null
  
)

export default component.exports